module.exports = __webpack_public_path__ + "img/flower-right.96780569.svg";